module.exports = __webpack_public_path__ + "img/wall.e98fc51f.jpg";